<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>工单管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">待排期工单</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section
      v-show="
        !hideInAddShow &&
          !hideInUserEdit &&
          !hideInSend &&
          !hideInDetails &&
          !hideInBatchOrders
      "
    >
      <section class="searchBox">
        <span class="addStyle">
          <a-button
            type="primary"
            icon="plus"
            @click="hideInAddShow = !hideInAddShow"
            style="margin-right:10px"
            >增加</a-button
          >
          <a-button @click="hideInBatchOrders = true" style="margin-right:10px"
            >批量排期</a-button
          >
        </span>
        <!-- <span>
          <label>公寓状态：</label>
          <a-radio-group>
            <a-radio :value="2">正常</a-radio>
            <a-radio :value="1">禁用</a-radio>
          </a-radio-group>
        </span>-->
        <span>
          <label>项目：</label>
          <a-select
            style="min-width:160px"
            v-model="project_id"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="element in proList"
              :key="element.id"
              :value="element.id"
              >{{ element.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>字符串：</label>
          <a>
            <a-input
              v-model="nameSearch"
              placeholder="名称 | 地址"
              style="margin-right:10px;width:160px"
            />
          </a>
        </span>
        <span>
          <a-button style="margin-right:10px" @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.name }}</td>
              <!-- <td>正常</td> -->
              <td>
                <p v-if="item.washroom_type == 1">单卫</p>
                <p v-else-if="item.washroom_type == 2">双卫</p>
                <p v-else-if="item.washroom_type == 3">三卫</p>
                <p v-else>未知</p>
              </td>
              <td>
                <p v-if="item.password_type == 1">{{ item.password }}</p>
                <p v-else-if="item.password_type == 2">临时密码</p>
                <p v-else>未知</p>
              </td>
              <td>
                <p v-if="item.is_compound == 1">是</p>
                <p v-else-if="item.is_compound == 2">否</p>
                <p v-else>未知</p>
              </td>
              <td>
                <p>{{ item.customer_user_names }}</p>
              </td>
              <td>{{ item.remark }}</td>
              <td class="operation">
                <a style="color:#909399" @click="detailPage(item)">详情</a>
                <a style="color:#409EFF" @click="sendOrders(item)">排期</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>

    <!-- 增加 -->
    <addHouse v-on:hideInAdd="hideInAdd" v-show="hideInAddShow" />
    <!-- 增加 end-->
    <!-- 批量派单 -->
    <batchSendOrders v-show="hideInBatchOrders" />
    <!-- 批量派单 end -->
    <!-- 编辑 -->
    <houseEdit
      v-on:hideInEdit="hideInEdit"
      v-show="hideInUserEdit"
      :editDetail="editDetail"
    />
    <!-- 编辑  end-->
    <!-- 派单 -->
    <sendOrder
      :sendDetail="sendDetail"
      v-show="hideInSend"
      v-on:hideInSendOrder="hideInSendOrder"
    />
    <!-- 派单 end -->
    <!-- 详情 -->
    <houseDetails v-show="hideInDetails" :detail="detail" />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import addHouse from "@/components/clean/addHouse"; //增加
import batchSendOrders from "@/components/clean/batchSendOrders"; //批量派单
import houseEdit from "@/components/clean/houseEdit"; //编辑
import sendOrder from "@/components/clean/sendOrder"; //派单
import houseDetails from "@/components/clean/houseDetails"; //详情
export default {
  components: {
    addHouse,
    houseEdit,
    sendOrder,
    houseDetails,
    batchSendOrders
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddShow: false,
      query_field: "",
      typeSearch: -1,
      hideInUserEdit: false,
      editDetail: {},
      totalPage: Number,
      nameSearch: "",
      thList: [
        "项目名",
        "公寓名称",
        // "状态",
        "卫生间类型",
        "密码",
        "是否为复式",
        "综合员工",
        "备注",
        "操作"
      ],
      sendDetail: {},
      hideInSend: false,
      hideInDetails: false,
      hideInBatchOrders: false,
      detail: {},
      project_id: "",
      proList: []
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 3
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    hideInAdd(msg) {
      this.hideInAddShow = msg;
      this.reload();
    },
    hideInEdit(msg) {
      this.hideInUserEdit = msg;
      this.reload();
    },
    hideInSendOrder(msg) {
      this.hideInSend = msg;
      this.reload();
    },
    showInUserList() {
      this.hideInAddShow = false;
      this.hideInUserEdit = false;
      this.hideInSend = false;
      this.hideInDetails = false;
      this.hideInBatchOrders = false;
    },
    detailPage(val) {
      this.detail = val;
      this.hideInDetails = true;
    },
    onSearch(value) {
      this.page = 1;
      this.getData();
    },
    onReset() {
      this.nameSearch = "";
      this.project_id = "";
      this.page = 1;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.data = [];
      let url = this.httpsBasic.url + this.httpsBasic.clean + "House/houseList";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.nameSearch,
          project_id: this.project_id,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(detail) {
      this.hideInUserEdit = true;
      this.editDetail = detail;
    },
    sendOrders(detail) {
      this.hideInSend = true;
      this.sendDetail = detail;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    display: block;
    > span {
      display: inline-block;
      margin-right: 10px;
      margin-bottom: 10px;
      > a {
        display: inline-block;
      }
    }
    .addStyle {
      margin-right: 20px;
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
